import React, { useState, useEffect } from 'react';
import { getMyOrders } from '../../services/venueService';

const OrderHistory = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    getMyOrders().then(setOrders);
  }, []);

  return (
    <div className="bg-white rounded-lg shadow overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="text-left border-b">
            <th className="p-3">Date</th>
            <th className="p-3">Status</th>
            <th className="p-3">Venue fee</th>
          </tr>
        </thead>
        <tbody>
          {orders.map(order => (
            <tr key={order._id} className="border-b">
              <td className="p-3">{new Date(order.scheduledDate).toLocaleDateString()}</td>
              <td className="p-3">{order.status}</td>
              <td className="p-3">₦{order.pricing.venueFee.toLocaleString()}</td>
            </tr>
          ))}
          {orders.length === 0 && (
            <tr><td className="p-3 text-gray-500" colSpan={3}>No orders yet</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default OrderHistory;
